import React, { useState } from "react";
import Drawer from "react-drag-drawer";
import FormCallUs from "./faleconosco-form/index";

const CallUsModal = ({
  show_callus,
  show_callus_title,
  show_callus_text1,
  show_callus_text2,
  toggle_callus,
  isSuccess,
  setIsSuccess
}) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Drawer dontApplyListeners={true} open={show_callus} onRequestClose={() => toggle_callus(false)}>
      <div className="modal modal-callus">
        <div className="modal-container-callus">
          <h2 style={{ padding: 10, marginBlockEnd: 0 }}>{show_callus_title}</h2>
          <p style={{ padding: 10, margin: 0 }}>
            {show_callus_text1}
          </p>
          <FormCallUs
            toggle_callus={toggle_callus}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            isSuccess={isSuccess}
            setIsSuccess={setIsSuccess}
          />
          <p style={{ padding: 10 }}>
            {show_callus_text2}
          </p>
        </div>
      </div>
    </Drawer>
  );
};
export default CallUsModal;